import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

/**
 * Magnifying-glass nav button (works for everyone, signed-in or not).
 * Clicking pops a search bar overlay; submitting navigates to the full /search
 * results page so people can browse everything rather than being forced to pick
 * a single result (unlike the Cmd+K command palette).
 */
export function SearchNavButton({ className = "" }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");

  const submit = () => {
    const term = q.trim();
    if (!term) return;
    setOpen(false);
    setQ("");
    navigate(`/search?q=${encodeURIComponent(term)}`);
  };

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className={className}
        onClick={() => setOpen(true)}
        title="Search"
        aria-label="Search"
        data-testid="nav-search-button"
      >
        <Search className="h-5 w-5" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="top-[18%] translate-y-0 gap-3 p-5" data-testid="search-overlay">
          <DialogTitle>Search Startup Otter</DialogTitle>
          <DialogDescription className="sr-only">
            Search people, businesses, capital, events and resources.
          </DialogDescription>
          <div className="flex items-center gap-2">
            <div className="flex-1">
              <Input
                autoFocus
                value={q}
                onChange={(e) => setQ(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && submit()}
                placeholder="Search people, businesses, capital, events, resources…"
                data-testid="search-overlay-input"
              />
            </div>
            <Button onClick={submit} data-testid="search-overlay-submit">Search</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
